'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { Container } from '@/components/ui/Container';
import { Section } from '@/components/ui/Section';
import { Heading } from '@/components/ui/Heading';
import { Text } from '@/components/ui/Text';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <Section>
      <Container>
        <Heading as="h1">Something went wrong</Heading>
        <Text size="lg">Please try again, or return to the homepage.</Text>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <button onClick={() => reset()}>Try again</button>
          <Link href="/">Go home</Link>
        </div>
      </Container>
    </Section>
  );
}
